module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6ePyd"))).then(() => parcelRequire('d0iPb'));